import styled from 'styled-components';
import {useCustomTheme} from 'context/customTheme';
import {Loader} from '@guestapp/old-ui-kit';

export const LoadingWrapper = styled.div`
  height: 100vh;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const AuthPageLoader = () => {
  const {finalTheme} = useCustomTheme();
  const {colors} = finalTheme;

  return (
    <LoadingWrapper>
      <Loader color={colors.branding.primary} width={60} height={60} />
    </LoadingWrapper>
  );
};
